'use client';

import { type PropsWithChildren } from 'react';
import type { RatingProduct } from '@packages/gql/generated/shopping/graphql';
import { useAddCustomerReviewAllowed } from '../../CustomerReviews/useAddCustomerReviewAllowed/useAddCustomerReviewAllowed';

export type CheckRenderSectionProps = PropsWithChildren<{
  reviewCount: RatingProduct['reviewCount'];
}>;

/* 
    The whole DV customer rating section has to be deactivated if:
      - writeCustomerRatingEnabled is false
      - there are no customer ratings for a product available

    This would end up into an empty section which should be avoided.
  */

export const CheckRenderSection = ({ children, reviewCount }: CheckRenderSectionProps) => {
  const addCustomerReviewAllowed = useAddCustomerReviewAllowed();

  if (!addCustomerReviewAllowed && reviewCount === 0) return null;

  return children;
};
